import {
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import _ from 'lodash';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { SaveProductDetailsModal } from 'modules/components/layer17';
import { CustomIcon } from 'modules/components/layer00';
import { useAccessState } from 'modules/common';
import React, { useState } from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';


type IProps = {
  stroke: string;
};

type IBaseModalProps = (props: IProps) => JSX.Element;

export type InstallationProductDetailsProps = {};
type IFieldName =
'NAME' |
'SUPPLIER' |
'MANUFACTURER' |
'MODEL' |
'HARDWARE' |
'FINISH' |
'NOTES';

const fieldName: IFieldName[] = [
  'NAME',
  'SUPPLIER',
  'MANUFACTURER',
  'MODEL',
  'HARDWARE',
  'FINISH',
  'NOTES'
];

const __field2Icon: Record<IFieldName, IBaseModalProps > = {
  NAME: (props: IProps) => <CustomIcon.large.FC {...props}icon='ROOM' />,
  SUPPLIER: (props: IProps) => <CustomIcon.large.FC {...props}icon='SHOP' />,
  MANUFACTURER: (props: IProps) => <CustomIcon.large.FC {...props}icon='TAG' />,
  MODEL: (props: IProps) => (<CustomIcon.large.FC {...props} icon='MODEL' />),
  HARDWARE: (props: IProps) => <CustomIcon.large.FC {...props} icon='AREA' />,
  FINISH: (props: IProps) => <CustomIcon.large.FC {...props} icon='SPARKLE' />,
  NOTES: (props: IProps) => <CustomIcon.large.FC {...props} icon='FILE' />
};


export type InstallationProductCardProps = {};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationProductCardProps) => {
  const params = useParams();
  const theme = useTheme();
  const { data } = ds.useQuery(params.installationId ?? '');


  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const access = useAccessState('Product');


  return (
    <>
      {
        isVisible && (
          <SaveProductDetailsModal.FC
            id={data.id}
            handleClose={() => setIsVisible(() => false)}
            isVisible={isVisible}
          />
        )
      }
      <ActivityDetailSectionCardBaseLayout.FC
        title='Product'
        subTitle='Product Finish information.'
        actionButton={
          // we have data
          !data.id
            ? {
              text: 'Add Product information',
              onClick: () => {
                setIsVisible(() => true);
              },
              disabled: !access.create
            }
            : null
        }
        isEmpty={data.id ? false : true}
        editActionButton={
          data.id
            ? {
              text: 'Edit',
              onClick: () => {
                setIsVisible(() => true);
              },
              disabled: !access.update
            }
            : null
        }
      >
        <Stack
          rowGap='1rem'
          justifyContent='center'
        >
          {fieldName.map((node, i) => {
            const Icon = __field2Icon[node];
            return (
              <Stack
                key={i}
                columnGap='.5rem'
                alignItems='center'
                direction='row'
              >
                <Icon
                  stroke={theme.palette.primary.main}
                />

                <Typography
                  variant='formLabel'
                >
                  {_.upperFirst(_.lowerCase(node)) }
                </Typography>
                <Typography
                  variant='formInput'
                >
                  {
                    data[_.lowerCase(node)]
                  }
                </Typography>
              </Stack>
            );
          })}
        </Stack>
      </ActivityDetailSectionCardBaseLayout.FC>
    </>
  );
};
